import { Col, Drawer, Row, Spin, Input, DatePicker } from "antd";
import dayjs from "dayjs";
import {
  left_arrow_icon,
  add_icon,
  calender_colored_icon,
} from "../../assets/icons/icons";
import { uploadImage } from "../../helpers/helpers";
import {
  ThemeButton,
  ThemeInput,
  UploadUserProfile,
  ThemeSelect,
} from "../components";
import options from "../../lib/data/options.json";
import { get } from "lodash";

const SponsorDrawer = ({
  open,
  btnTxt,
  addIcon,
  onSubmit,
  isLoading,
  formData,
  setFormData,
  image,
  setImage,
  onClose,
  mode,
  formErrors
}) => {
  const handleImage = async (e) => {
    const res = await uploadImage(e.target.files[0]);
    setImage(res);
    setFormData({
      ...formData,
      picture: res,
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  console.log("formErrors", formErrors)

    const phoneError = get(formErrors, "metadata.delegate_details.phone", "");
  return (
    <Drawer
      width={600}
      title={btnTxt}
      placement="right"
      onClose={onClose}
      open={open}
      closeIcon={<img src={left_arrow_icon} alt="" width={18} height={18} />}
      extra={
        <ThemeButton
          onClick={onSubmit}
          className={"ml-4 w-40"}
          content={
            <>
              {isLoading ? (
                <Spin className="mt-1" />
              ) : (
                <div className="flex items-center">
                  {addIcon && (
                    <img
                      src={add_icon}
                      alt=""
                      width={18}
                      height={18}
                      className="mr-2"
                    />
                  )}
                  <p>{btnTxt}</p>
                </div>
              )}
            </>
          }
        />
      }
    >
      <div className="flex justify-center">
        <UploadUserProfile image={image} onChange={handleImage} />
      </div>
      <Row className="mt-6" gutter={{ xs: 8, sm: 16, md: 20, lg: 20 }}>
        <Col span={12} className="mb-4">
          <ThemeInput
            label={<span className="flex items-center gap-1">First Name<span className="text-red-500">*</span> </span>}
            placeholder={"First name"}
            onChange={handleChange}
            value={formData.first_name}
            name="first_name"
            labelPrimary
            error={formErrors}
          />

          {formErrors.first_name && (
            <p className="text-red-500 text-xs mt-1">{formErrors.first_name}</p>
          )}

        </Col>
        <Col span={12} className="mb-4">
          <ThemeInput
            label={"Last Name"}
            placeholder={"Last name"}
            onChange={handleChange}
            value={formData.last_name}
            name="last_name"
            labelPrimary
          />
        </Col>
        <Col span={12} className="mb-4">
          <ThemeInput
            label={"Company"}
            placeholder={"companay"}
            onChange={(e) =>
              setFormData({
                ...formData,
                metadata: {
                  ...formData.metadata,
                  delegate_details: {
                    ...formData.metadata.delegate_details,
                    company: e.target.value,
                  },
                },
              })
            }
            value={formData?.metadata?.delegate_details?.company}
            name="text"
            labelPrimary
          />
        </Col>
        <Col span={12} className="mb-4">
          <ThemeInput
            label={"Position"}
            placeholder={"position"}
            onChange={(e) =>
              setFormData({
                ...formData,
                metadata: {
                  ...formData.metadata,
                  delegate_details: {
                    ...formData.metadata.delegate_details,
                    position: e.target.value,
                  },
                },
              })
            }
            value={formData?.metadata?.delegate_details?.position}
            name="text"
            labelPrimary
          />
        </Col>
        <Col span={24} className="mb-4">
          <ThemeInput
            type="email"
            label={<span className="flex items-center gap-1">Email<span className="text-red-500">*</span> </span>}
            name="email"
            placeholder={"email"}
            onChange={handleChange}
            value={formData.email}
            labelPrimary
          // disabled={mode === "edit"}
          error={formErrors}
          />
            {formErrors.email && (
            <p className="text-red-500 text-xs mt-1">{formErrors.email}</p>
          )}
        </Col>
        <Col span={12} className="mb-4">
          <ThemeInput
            type="number"
            label={<span className="flex items-center gap-1">Phone<span className="text-red-500">*</span> </span>}
            placeholder={"phone"}
            onChange={(e) =>
              setFormData({
                ...formData,
                metadata: {
                  ...formData.metadata,
                  delegate_details: {
                    ...formData.metadata.delegate_details,
                    phone: e.target.value,
                  },
                },
              })
            }
            value={formData?.metadata?.delegate_details?.phone}
            name="text"
            labelPrimary
            error={phoneError}
          />
            {phoneError && (
            <p className="text-red-500 text-xs mt-1">{phoneError}</p>
          )}
        </Col>
        <Col span={12} className="mb-4">
          <ThemeInput
            type="number"
            label={"Mobile"}
            placeholder={"mobile"}
            onChange={(e) =>
              setFormData({
                ...formData,
                metadata: {
                  ...formData.metadata,
                  delegate_details: {
                    ...formData.metadata.delegate_details,
                    mobile: e.target.value,
                  },
                },
              })
            }
            value={formData?.metadata?.delegate_details?.mobile}
            name="text"
            labelPrimary
          />
        </Col>
        <Col span={12} className="mb-4">
          <ThemeInput
            label={<span className="flex items-center gap-1">Password<span className="text-red-500">*</span> </span>}
            placeholder={"password"}
            name={"password"}
            value={formData.password}
            onChange={handleChange}
            labelPrimary
            error={formErrors}
          />
            {formErrors.password && (
            <p className="text-red-500 text-xs mt-1">{formErrors.password}</p>
          )}
        </Col>
        <Col span={12} className="mb-4">
        <p className="text-primary text-semibold font-medium">Gender <span className="text-red-500 p-1">*</span></p>
          <ThemeSelect
            placeholder={"Gender"}
            value={formData.gender}
            onChange={(value) => setFormData({ ...formData, gender: value })}
            options={options?.genders}
            className={"w-full"}
            error={formErrors}
          />
            {formErrors.gender && (
            <p className="text-red-500 text-xs mt-3">{formErrors.gender}</p>
          )}
        </Col>
        <Col span={12} className="mb-4">
          <ThemeInput
            label={"Website"}
            placeholder={"website"}
            name={"website"}
            value={formData?.metadata?.delegate_details?.website}
            onChange={(e) =>
              setFormData({
                ...formData,
                metadata: {
                  ...formData.metadata,
                  delegate_details: {
                    ...formData.metadata.delegate_details,
                    website: e.target.value,
                  },
                },
              })
            }
            labelPrimary
          />
        </Col>
        <Col span={12} className="mb-4">
          <ThemeInput
            label={"LinkedIn"}
            placeholder={"linkedIn"}
            name={"linkedIn"}
            value={formData?.metadata?.delegate_details?.linkedIn}
            onChange={(e) =>
              setFormData({
                ...formData,
                metadata: {
                  ...formData.metadata,
                  delegate_details: {
                    ...formData.metadata.delegate_details,
                    linkedIn: e.target.value,
                  },
                },
              })
            }
            labelPrimary
          />
        </Col>
        <Col span={24} className="mb-4">
          <p className="font-semibold mb-1 text-primary">Personal Profile</p>
          <Input.TextArea
            placeholder="Personal Profile"
            name={"personal_profile"}
            value={formData?.metadata?.delegate_details?.personal_profile}
            onChange={(e) =>
              setFormData({
                ...formData,
                metadata: {
                  ...formData.metadata,
                  delegate_details: {
                    ...formData.metadata.delegate_details,
                    personal_profile: e.target.value,
                  },
                },
              })
            }
            rows={4}
            className="font-medium pt-2"
          />
        </Col>
        <Col span={24} className="mb-4">
          <p className="font-semibold mb-1 text-primary">Company Profile</p>
          <Input.TextArea
            placeholder="Company Profile"
            name={"company_profile"}
            value={formData?.metadata?.delegate_details?.company_profile}
            onChange={(e) =>
              setFormData({
                ...formData,
                metadata: {
                  ...formData.metadata,
                  delegate_details: {
                    ...formData.metadata.delegate_details,
                    company_profile: e.target.value,
                  },
                },
              })
            }
            rows={4}
            className="font-medium pt-2"
          />
        </Col>

        <Col span={24} className="mb-4">
          <p className="font-semibold mb-1 text-primary">Customize Details</p>
          <Input.TextArea
            placeholder="write your cutomize details here"
            name={"customize_details"}
            onChange={(e) =>
              setFormData({
                ...formData,
                metadata: {
                  ...formData.metadata,
                  package_details: {
                    ...formData.metadata.package_details,
                    customize_details: e.target.value,
                  },
                },
              })
            }
            value={formData?.metadata?.package_details?.customize_details}
            rows={5}
            className="font-medium pt-2"
          />
        </Col>
      </Row>
    </Drawer>
  );
};

export default SponsorDrawer;
